// ============================================================
//  FIREBASE CONFIG — v10 Modular SDK
//  Config values are public identifiers — security comes from
//  Firebase Security Rules + Firebase Authentication.
// ============================================================

import { initializeApp, getApps }       from 'firebase/app';
import { getDatabase }                   from 'firebase/database';
import { getAuth, signInAnonymously,
         signInWithEmailAndPassword,
         signOut, onAuthStateChanged }   from 'firebase/auth';
import type { User }                     from 'firebase/auth';

const FIREBASE_CONFIG = {
  apiKey:            'AIzaSyAb-0mO8WgG9zBh-lCkvX1AEDM__iBo1_Q',
  authDomain:        'fleetops-1ec67.firebaseapp.com',
  databaseURL:       'https://fleetops-1ec67-default-rtdb.firebaseio.com',
  projectId:         'fleetops-1ec67',
  storageBucket:     'fleetops-1ec67.firebasestorage.app',
  messagingSenderId: '533465719895',
  appId:             '1:533465719895:web:8fe0f576fdb537a0cc2f12',
  measurementId:     'G-7VN0WWNMXM',
};

const app  = getApps().length === 0 ? initializeApp(FIREBASE_CONFIG) : getApps()[0];
export const db   = getDatabase(app);
export const auth = getAuth(app);

// Admin signs in with email + password — credentials never stored in code
export async function signInAdmin(email: string, password: string): Promise<User> {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred.user;
}

// Crew signs in anonymously — no credentials needed
export async function signInCrew(): Promise<User> {
  const cred = await signInAnonymously(auth);
  return cred.user;
}

export async function firebaseSignOut(): Promise<void> {
  await signOut(auth);
}

export { onAuthStateChanged };
export type { User };